"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Task = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.286 0.636v7.642a0.636 0.636 0 0 1-0.637 0.636H6.494a0.636 0.636 0 0 1-0.636-0.636v-7.642A0.636 0.636 0 0 1 6.494 0h3.156a0.636 0.636 0 0 1 0.636 0.636zm5.089-0.636h-3.183a0.636 0.636 0 0 0-0.636 0.636v4.138a0.318 0.318 0 0 0 0.317 0.318h3.82a0.318 0.318 0 0 0 0.318-0.318V0.636A0.636 0.636 0 0 0 15.375 0zm0.319 6.364h-3.821a0.318 0.318 0 0 0-0.318 0.318v3.774a1.273 1.273 0 0 0 1.273 1.273h1.909a1.273 1.273 0 0 0 1.274-1.273V6.682a0.318 0.318 0 0 0-0.317-0.318zM3.947 0H0.763a0.636 0.636 0 0 0-0.636 0.636v4.138a0.318 0.318 0 0 0 0.318 0.318h3.82a0.318 0.318 0 0 0 0.318-0.318V0.636A0.636 0.636 0 0 0 3.947 0zm0.319 6.364h-3.82a0.318 0.318 0 0 0-0.318 0.318V12.73a1.273 1.273 0 0 0 1.273 1.273h1.91a1.273 1.273 0 0 0 1.273-1.273V6.682a0.318 0.318 0 0 0-0.318-0.318z",
  className: "fill"
}));
var _default = exports.default = Task;